module.exports = __webpack_public_path__ + "1901cd18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/dialog_order_finished_en.png
// module id = 1501
// module chunks = 0